import { useState } from "react";
import { Modal, Button, Alert } from "antd";
import toast from "react-hot-toast";
import api from "../../../services/api";

const RemoveFeaturedTeachersModal = ({
  show,
  onCancel,
  selectedTeacher,
  refreshData,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!selectedTeacher) {
      toast.error("Please select teacher");
      return;
    }
    setLoading(true);

    try {
      const req = await api.put(
        "/admin/teachers/featured",
        { teacherId: selectedTeacher?.id }
      );
      if (req.status === 200) {
        // eslint-disable-next-line
        toast.success("Removed successfully!");
        onCancel();
        refreshData();
      }
    } catch (error) {
      toast.error("Error" + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={show}
      onCancel={onCancel}
      footer={null}
      title={`Remove Featured Teacher`}
    >
      <div className="space-y-5">
        <div className="my-4">
          <Alert
            message={`Are you sure you want to remove "${selectedTeacher?.fullName}" from the featured teachers list?`}
            type="warning"
            showIcon
          />
        </div>

        <div className="d-flex justify-content-end gap-2 mt-2">
          <Button
            onClick={onCancel}
            className="btn btn_outlined fs_12 btn-sm text-black px-3"
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleSend}
            loading={loading}
            className="btn btn_contained fs_12 btn-sm text-white px-3"
          >
            Remove
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveFeaturedTeachersModal;
